export default __webpack_public_path__ + "static/media/section4-webdev.c6227063.jpeg";